import { render, staticRenderFns } from "./ProjectCommunication.vue?vue&type=template&id=7c702fd6&scoped=true"
import script from "./ProjectCommunication.vue?vue&type=script&lang=js"
export * from "./ProjectCommunication.vue?vue&type=script&lang=js"
import style0 from "./ProjectCommunication.vue?vue&type=style&index=0&id=7c702fd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c702fd6",
  null
  
)

export default component.exports